import React, { Component } from 'react';
import _ from 'lodash';

import { updateStepIfDifferent } from '../../helpers/routes';
import * as QuizHelpers from '../../helpers/quiz';

class Kids extends Component {
  constructor (props) {
    super(props);
    this._nextStep = this._nextStep.bind(this);
    this._validate = this._validate.bind(this);
    this._isInRange = this._isInRange.bind(this);
  }

  state = {
    kids: this.props.quiz.fieldValues.KidsCount,
    message: false,
    animate: ''
  };

  componentWillMount () {
    if (this.props.quiz.fieldValues.FamilyType === 'Couple') {
      this.props.stepMethods.nextStep();
    }
  }

  componentDidMount () {
    const p = _.clone(this.props);
    QuizHelpers.sendAnalyticsOnQuestion(`${p.route}`, '# Kids');
    setTimeout(() => {
      this.setState({
        animate: 'fadeIn'
      });
    }, 600);
  }

  _nextStep () {
    const p = _.clone(this.props);
    p.stepMethods.setStep(p.quiz.step + 1);
  }

  _prevStep () {
    window.history.go(-1);
  }

  _handleKidsChange (kidsCount) {
    if (kidsCount.length <= 2) this.props.reducer(kidsCount);
  }

  _isInRange (values = this.props.quiz.fieldValues) {
    let household = (values.FamilyType === 'CoupleChildren' ? 2 : (
      (values.FamilyType === 'IndividualChildren' || values.FamilyType === 'ChildrenOnly') ? 1 : 0
    ));

    let calculated = (values.KidsCount) ? parseFloat(values.KidsCount) + household : '';
    if (calculated <= values.TotalFamilySize) return true;
    return false;
  }

  _validate (values = this.props.quiz.fieldValues) {
    const isValid = (values.KidsCount.length > 0 && this._isInRange(values) === true);
    if (!isValid) updateStepIfDifferent(this.props.quiz.step);
    return isValid;
  }

  render () {
    let p = _.clone(this.props);
    const { TotalFamilySize, KidsCount } = p.quiz.fieldValues;
    let notice;

    const isEnabled = this._validate(p.quiz.fieldValues);

    if (!this._isInRange(p.quiz.fieldValues)) {
      notice = <p className='alert'>
        This makes your family larger than previously mentioned.<br />
        <a
          onClick={(e) => (this._prevStep())}
        >Update your household size of {TotalFamilySize}?</a>
      </p>;
    }

    return (
      <section className={'p30 animate ' + this.state.animate}>
        <div className='wrap text-center'>
          <h3>How many kids do you have under the age&nbsp;of&nbsp;19?</h3>
          <p>Children under age 19 may be eligible for free or low cost programs.</p>
          <p className='form'>
            <input
              id='kids'
              autoFocus
              type='number'
              name='KidsCount'
              maxLength='2'
              ref={(input) => { this.kids = input; }}
              value={KidsCount}
              onChange={(e) => this._handleKidsChange(e.target.value)}
              onKeyUp={(e) => (e.which === 13 && isEnabled && this._nextStep())}
            />
            {this.props.stepMethods.isNextStep() &&
              <button
                className={'btn next ' + isEnabled}
                disabled={!isEnabled}
                onClick={this._nextStep}
              >Next</button>
            }
            <button className='btn back' onClick={this.props.stepMethods.prevStep}>Previous</button>
          </p>
          <div className={'message' + (notice ? ' show' : '')}>
            {notice}
          </div>
        </div>
      </section>
    );
  }
}

export default Kids;



// WEBPACK FOOTER //
// ./src/components/Questions/Kids.jsx